var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerElementPurpose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69829 0.5C5.25315 0.5 4.85185 0.75887 4.6815 1.1559C4.51115 1.55293 4.60531 2.00993 4.92007 2.3138L5.69829 3.0651V7.0573C5.69829 7.33909 5.58234 7.60934 5.37594 7.8086L0.973667 12.0586C-1.10629 14.0666 0.366817 17.5 3.30833 17.5H14.6917C17.6332 17.5 19.1063 14.0666 17.0263 12.0586L12.6241 7.8086C12.4177 7.60934 12.3017 7.33909 12.3017 7.0573V3.0651L13.0799 2.3138C13.3947 2.00993 13.4888 1.55293 13.3185 1.1559C13.1482 0.75887 12.7468 0.5 12.3017 0.5H5.69829ZM7.89943 7.0573V2.625H10.1006V7.0573C10.1006 7.90267 10.4484 8.71343 11.0676 9.3112L12.1985 10.403C11.4096 10.2258 10.5824 10.2617 9.80896 10.5106L9.2915 10.6771C8.38785 10.9679 7.41089 10.9679 6.50725 10.6771L5.88823 10.4779C5.84632 10.4644 5.80419 10.4522 5.76187 10.4412L6.93238 9.3112C7.55157 8.71343 7.89943 7.90267 7.89943 7.0573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerElementPurpose);
export default __webpack_public_path__ + "static/media/marker_Element_purpose.1ef089456368d6d08729f5b3d0af2f28.svg";
export { ForwardRef as ReactComponent };